import { type ReactNode, forwardRef } from 'react';

import { type Search } from '@vakantiesnl/types';

import { AccommodationDescription } from './AccommodationDescription';

export type AccommodationWithDescriptionType = Pick<Search.FullAccommodationItem, 'description'>;

type Props = {
	accommodation: AccommodationWithDescriptionType;
	title?: ReactNode | string;
};

export const AccommodationDescriptionWrapper = forwardRef<HTMLDivElement, Props>(({ accommodation, title }, ref) => {
	if (!accommodation.description?.paragraphs && !accommodation.description?.headerDescription) return null;

	return (
		<AccommodationDescription
			title={title}
			descriptionTitle={accommodation.description?.headerTitle}
			description={accommodation.description?.headerDescription}
			paragraphs={accommodation.description?.paragraphs}
			ref={ref}
		/>
	);
});
AccommodationDescriptionWrapper.displayName = 'AccommodationDescriptionWrapper';
